import { parseJSON } from '@rsos/utils';
import {
  MEDICALERT,
  MEDICALERT_CA,
  MEDICALERT_UK,
} from '../../actions/fetchEmergencySession';

/**
 * @function fetchRetryWithADR checks the scheme of searchTerm
 * attempts the given fetch request recursively until
 * the limit is reached or ADR orgName is found
 * @param {scheme} - 'tel' or 'maf-id'
 */
const fetchRetryWithADR = (url, options, scheme) => {
  if (scheme === 'tel') {
    const doRecursiveRequest = (url, options, limit = 5) => {
      return fetch(url, options)
        .then(parseJSON)
        .then(res => {
          let payload = res;
          for (const orgName in payload) {
            if (
              orgName === MEDICALERT ||
              orgName === MEDICALERT_CA ||
              orgName === MEDICALERT_UK
            ) {
              continue;
            } else {
              return res;
            }
          }
          limit--;
          if (limit) {
            return doRecursiveRequest(url, options, limit);
          } else {
            return res;
          }
        });
    };

    return doRecursiveRequest(url, options).then(() => {
      return fetch(url, options).then(response => {
        return response;
      });
    });
  } else {
    return fetch(url, options).then(res => {
      return res;
    });
  }
};

export default fetchRetryWithADR;
